import React, { Component } from "react";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import "./Modal.css";
import CustomButton from "../CustomButton/CustomButton";
import GoogleLogin from "./GoogleLogin";
import axios from 'axios';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { connect } from "react-redux";
import {
  trySelectGiftCard,
  setGiftCardPinNumber,
  resetCurrentGiftCard,
  addGiftCard,
  resetCurrentAmount,
  resetPointAmount
} from "../../../actions/giftCard";
import { InputStep, typingTimeout } from "../../Checkout/Checkout";
import {
  resetGiftCard,
  removeGiftCard,
  setGiftCardNumber,
  setPointNumber,
  getPointsCard
} from "../../../actions/giftCard";
import MaskedInput from "react-text-mask";
import { roundThis } from "../../../utilities/utils";
import { getPrice } from "../../../selectors";
import { getDiscount } from "../../../selectors/discount";
// import { DefaultModalParams } from "./Modal";
// I'm not actualyl sure if we need the below
// import Modal, { DefaultModalParams } from '../SubComponents/Modal/Modal';

const mapStateToProps = state => {
  // TODO: this is very bad practice because we are already doing this elsewhere
  // I would love to have all information about total price and everything in the redux state so we don't have to do this calculation here (and only will need it in PriceBar)
  const discountInfo = getDiscount(state);
  const priceInfo = getPrice(state, discountInfo);
  const subTotal = Math.max(priceInfo.basePrice - priceInfo.discount, 0);

  return {
    giftCards: state.giftCard.array,
    currentAmount: state.giftCard.current_gift_card_amount,
    currentCard: state.giftCard.current_gift_card_number,
    total: subTotal + priceInfo.tax - state.giftCard.total_amount,
    currencySymbol: state.bookingLocation.selectedLocation.currency_symbol,
    base_price: roundThis(
      5
    ).toFixed(2),
    enableGiftCard: state.checkout.giftCardEnabled
  };
};

const mapDispatchToProps = dispatch => ({
  trySelectGiftCard: (giftCardNumber, secCode) =>
    dispatch(trySelectGiftCard(giftCardNumber, secCode)),
  setGiftCardPinNumber: (pinNumber) => dispatch(setGiftCardPinNumber(pinNumber)),
  resetGiftCard: () => dispatch(resetGiftCard()),
  removeGiftCard: (giftCardNumber, amount) =>
    dispatch(removeGiftCard(giftCardNumber, amount)),
  addGiftCard: amt => dispatch(addGiftCard(amt)),
  setGiftCardNumber: giftCardNumber =>
    dispatch(setGiftCardNumber(giftCardNumber)),
  setPointNumber: pointsID => dispatch(setPointNumber(pointsID)),
  resetCurrentCard: () => dispatch(resetCurrentGiftCard()),
  resetCurrentAmount: () => dispatch(resetCurrentAmount()),
  resetPointAmount: () => dispatch(resetPointAmount()),
  getPointsCard: (response, loginType) =>
    dispatch(getPointsCard(response, loginType))
});

// Props
// title: string;
// content: string;
// acceptText: string;
// cancelText: string;
// isConfirm: boolean;
// onAccept?: () => void;
// onCancel?: () => void;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class Modal extends Component {
    // GIFT CARD SPECIFIC -----------------

    constructor(props) {
      super(props);
      this.state = {
        // vcard related states
        vcardTouched: false,
        vcardStep: InputStep.None,

        // MYSTUFF
        giftcardAmount: 0,
        giftCardNumber: "",
        vcardPin: "",

        // Points card related states
        pcardStep: InputStep.None,
        pointsAmount: 0,
        customerCardNumber: this.props.customerCardNumber ? this.props.customerCardNumber : "",

        displayHelp: false,

        // pointsModal states
        fineSelectPoints: false,
        pointsCustomAmount: 0,
        minAmountWarning: false
      };

      this.timeout = 0;

    }

    // Check if we have received new props, if so, update the state
    componentDidUpdate(prevProps, prevState) {
      // If we have supplied a new customer card number
      if (this.props.customerCardNumber !== prevState.customerCardNumber
        && this.props.customerCardNumber !== prevProps.customerCardNumber) {
        // change the existing one
        this.setState({ customerCardNumber: this.props.customerCardNumber });
      }
    }

    componentDidMount() {
      this.vcardTypingTimer = null;
      this.pointsTypingTimer = null;
      //check if we have a pre-filled customer card number
      if (this.props.usedLocalStorage) {
        console.log("setting from local storage")
        this.setState({
          customerCardNumber: this.props.customerCardNumber,
          vcardPin: ""
        });
        var objTemplate = {
          currentTarget: {
            value: this.state.customerCardNumber
          }
        }
        this.handlePointChange(objTemplate);
        this.handlePointsCardKeyUpSpecial();
        // this.forcePointsCardChange();
      }
    }

    handlePointsCardKeyUpSpecial(e, field) {
      // const curvcard = this.props.currentCard.replace(/\s/g, '');
      const curvcard = this.state.customerCardNumber?.toUpperCase();

      if (curvcard && curvcard !== "") {
        if (
          this.props.giftCards.find(e => e.giftcard_number === curvcard) !==
          undefined
        ) {
          this.setState({ pcardStep: InputStep.FoundAlreadyHave });
        } else {
          this.props
            .trySelectGiftCard(curvcard)
            .then(result => {
              if (curvcard.length === 20) {
                if (this.props.currentAmount >= this.props.base_price) {
                  this.setState({
                    pcardStep: InputStep.FoundCard,
                    pointsAmount: this.props.currentAmount
                  });
                } else {
                  this.setState({
                    pcardStep: InputStep.ThresholdNotMet,
                    pointsAmount: this.props.currentAmount
                  });
                }
              } else {
                this.setState({ pcardStep: InputStep.NotFoundCard });
              }
            })
            .catch(error => {
              this.setState({ pcardStep: error });
            });
        }
      }
    }

    handleGiftCardKeyUp(e, field) {
      clearTimeout(this.vcardTypingTimer);
      this.vcardTypingTimer = setTimeout(() => {
        // const curvcard = this.props.currentCard.replace(/\s/g, '');
        const curvcard = this.state.giftCardNumber?.toUpperCase();
        const fullStationStateObj = this.props.fullStationStateObj;

        if (curvcard && curvcard !== "") {
          // console.log(fullStationStateObj);
          const num5Cards = (this.props.giftCards.filter(e => e.giftcard_number.length === 14) || []).length;
          const numStations = (Object.values(fullStationStateObj.selectedStations).reduce(
            function (accumulator, currentValue) {
              // console.log(`e`, currentValue);
              let innerNumStations = 0;
              const itemIDs = Object.keys(currentValue);
              for (let i = 0; i < itemIDs.length; i++) {
                // console.log(`item (${itemIDs[i]}):`, currentValue[itemIDs[i]]);
                if (fullStationStateObj.stationsData.stations[itemIDs[i]].item_category_id === 1) {
                  // console.log("Found some stations");
                  innerNumStations += currentValue[itemIDs[i]];
                }
              }
              return accumulator + innerNumStations;
            }, 0)
          );

          // console.log(`curvcard`, curvcard);
          // console.log(`num5Cards`, num5Cards);
          // console.log(`numStations`, numStations);

          if (
            this.props.giftCards.find(e => e.giftcard_number === curvcard) !== undefined
          ) {
            this.setState({ vcardStep: InputStep.FoundAlreadyHave });
          } else if (
            curvcard.length === 14 &&
            num5Cards + 1 > numStations
          ) {
            console.log("More cards than stations");
            this.setState({ vcardStep: InputStep.MoreCardsThanStations });
          } else {
            this.props
              .trySelectGiftCard(curvcard, this.state.vcardPin)
              .then(result => {
                this.setState({
                  vcardStep: InputStep.FoundCard,
                  giftcardAmount: this.props.currentAmount
                });
              })
              .catch(error => {
                this.setState({ vcardStep: error, vcardPin: "" });
              });
          }
        }
      }, typingTimeout);
    }

    handleGiftCardChange = e => {
      if (e.currentTarget.value !== "")
        this.setState({ vcardStep: InputStep.Checking });
      else this.setState({ vcardStep: InputStep.None });

      const newCard = e.currentTarget.value?.toUpperCase().trim();
      console.log(newCard);

      this.setState({
        giftcardAmount: 0,
        giftCardNumber: newCard
      });

      this.props.setGiftCardNumber(newCard);
      this.props.resetCurrentAmount();
    };

    handleGiftCardPinChange = e => {
      const pin = e.target.value;
      this.setState({
        vcardPin: pin
      });
      if (this.timeout) clearTimeout(this.timeout);
      if (pin.length === 4) {
        console.info("Pin length reached", pin);
        this.updateGiftCard(e, pin);
      } else {
        this.timeout = setTimeout(() => {
          this.updateGiftCard(e, pin);
        }, 2000);
      }
    }

    updateGiftCard = (e, pin) => {
      this.props.setGiftCardPinNumber(pin);
      this.props.trySelectGiftCard(this.state.giftCardNumber, pin)
        .then(result => {
          this.updateFromPin();
        })
        .catch(err => {
          console.error(err);
        //   e.target.value = "";
        });
    }

    updateFromPin = () => {
      this.setState({ vcardStep: InputStep.LoadingBalance });
      this.handleGiftCardKeyUp();
    }

    // MYSTUFF
    forceGiftCardChange = () => {
      const el = document.getElementById("vcard");
      if (el) {
        el.value = this.state.giftCardNumber;
        if (el.value !== "") this.setState({ vcardStep: InputStep.Checking });
        else this.setState({ vcardStep: InputStep.None });
        this.props.setGiftCardNumber(el.value?.toUpperCase());
        this.props.resetCurrentAmount();
        this.handleGiftCardKeyUp();
      }
    };

    // MYSTUFF This is going to be used to autopopulate stuff
    forcePointsCardChange = () => {
      const el = document.getElementById("points");
      if (el) {
        el.value = this.state.customerCardNumber;
        if (el.value !== "") this.setState({ pcardStep: InputStep.Checking });
        else this.setState({ pcardStep: InputStep.None });
        // this.handleGiftCardKeyUp();
        this.props.setGiftCardNumber(el.value);
        this.props.resetCurrentAmount();
        this.handlePointsCardKeyUp();
      }
    };

    // MYSTUFF
    handlePointChange = e => {
      if (e.currentTarget.value !== "")
        this.setState({ pcardStep: InputStep.Checking });
      else this.setState({ pcardStep: InputStep.None });

      const newCard = e.currentTarget.value?.toUpperCase();

      this.setState({
        pointsAmount: 0,
        customerCardNumber: newCard
      });

      // You might need to change the below
      this.props.setGiftCardNumber(newCard);
      this.props.resetCurrentAmount();
    };

    // MYSTUFF
    handlePointsCardKeyUp(e, field) {
      clearTimeout(this.pointsTypingTimer);

      this.pointsTypingTimer = setTimeout(() => {
        // const curvcard = this.props.currentCard.replace(/\s/g, '');
        const curvcard = this.state.customerCardNumber?.toUpperCase();

        if (curvcard && curvcard !== "") {
          if (
            this.props.giftCards.find(e => e.giftcard_number === curvcard) !==
            undefined
          ) {
            this.setState({ pcardStep: InputStep.FoundAlreadyHave });
          } else {
            this.props
              .trySelectGiftCard(curvcard)
              .then(result => {
                if (curvcard.length === 20) {
                  if (this.props.currentAmount >= this.props.base_price) {
                    this.setState({
                      pcardStep: InputStep.FoundCard,
                      pointsAmount: this.props.currentAmount
                    });
                  } else {
                    this.setState({
                      pcardStep: InputStep.ThresholdNotMet,
                      pointsAmount: this.props.currentAmount
                    });
                  }
                } else {
                  this.setState({ pcardStep: InputStep.NotFoundCard });
                }
              })
              .catch(error => {
                this.setState({ pcardStep: error });
              });
          }
        }
      }, typingTimeout);
    }

    // MYSTUFF (This thing is so simple that I might as well just not make it a function. Just here for now)
    isPointsCode = number => {
      if (number.length === 20) return true;
      else return false;
    };

    // MYSTUFF (This isn't used yet)
    renderPointsTextField = body => {
      const textFieldClasses = classNames("TextField", body.className);

      const inputCheck = step => {
        switch (step) {
          case InputStep.Checking:
            return (
              <span className={"TextField-inputCheck--checking"}>
                {"Checking"}
              </span>
            );
          case InputStep.FoundCard:
            return (
              <span className={"TextField-inputCheck--green"}>
                {"Points found!"}
              </span>
            );
          case InputStep.NotFoundCard:
            return (
              <span className={"TextField-inputCheck--red"}>
                {"Invalid Points card"}
              </span>
            );
          case InputStep.FoundAlreadyHave:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {"Points card already added!"}
              </span>
            );
          case InputStep.ChargeOfZero:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {"Points card not needed!"}
              </span>
            );
          case InputStep.CardNoBalance:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {"Points card has no balance!"}
              </span>
            );
          case InputStep.CurrencyMismatch:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {"Points card currency mismatch!"}
              </span>
            );
          case InputStep.CardFoundNotAvailable:
            return (
              <span className={"TextField-inputCheck--red"}>
                {"Points card not available"}
              </span>
            );
          case InputStep.ThresholdNotMet:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {`Points threshold of ${this.props.currencySymbol}${this.props.base_price
                  } not met!`}
              </span>
            );
          default:
            return "";
        }
      };

      return (
        <div className={textFieldClasses} style={{ width: "100%" }}>
          <div className={"TextField-label"}>{body.label}</div>
          <MaskedInput
            className={"TextField-input"}
            type={"text"}
            // id={body.id}
            id={"points"}
            ref={body.ref}
            placeholder={"eg. 12345678901234567890"}
            // ref={(MaskedInput) => this.myinput = MaskedInput}
            value={this.state.customerCardNumber}
            onFocus={() => body.handleOnFocus}
            onBlur={() => {
              this.setState({ [body.id + "Touched"]: true });
            }}
            onChange={e => {
              this.handlePointChange(e);
            }}
            mask={false}
            // placeholder={body.placeholder}
            guide={false}
            autoComplete={"off"}
          />
          <div className={"TextField-errorMessage"} style={{ height: "auto" }}>
            {inputCheck(this.state.pcardStep)}
          </div>
        </div>
      );
    };

    renderTextField = body => {
      const textFieldClasses = classNames("TextField", body.className);

      const inputCheck = step => {
        switch (step) {
          case InputStep.Checking:
            return (
              <span className={"TextField-inputCheck--checking"}>
                {"Checking"}
              </span>
            );
          case InputStep.FoundCard:
            return (
              <span className={"TextField-inputCheck--green"}>
                {"Gift card found!"}
              </span>
            );
          case InputStep.PinNeeded:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {"Please enter PIN"}
              </span>
            );
          case InputStep.LoadingBalance:
            return (
              <span className={"TextField-inputCheck--checking"}>
                {"Loading balance from card"}
              </span>
            )
          case InputStep.NotFoundCard:
            return (
              <span className={"TextField-inputCheck--red"}>
                {"Invalid gift card"}
              </span>
            );
          case InputStep.FoundAlreadyHave:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {"Gift card already added!"}
              </span>
            );
          case InputStep.MoreCardsThanStations:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {"We can only honour one $5 card per VR station, so definitely save the extras for your next visit!"}
              </span>
            );
          case InputStep.ChargeOfZero:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {"Gift card not needed!"}
              </span>
            );
          case InputStep.CardNoBalance:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {"Gift card has no balance!"}
              </span>
            );
          case InputStep.CurrencyMismatch:
            return (
              <span className={"TextField-inputCheck--orange"}>
                {"Gift card currency mismatch!"}
              </span>
            );
          case InputStep.CardFoundNotAvailable:
            return (
              <span className={"TextField-inputCheck--red"}>
                {"Gift card not available"}
              </span>
            );
          default:
            return "";
        }
      };

      return (
        <div className={textFieldClasses} style={{ width: "100%" }}>
          <div className={"TextField-label"}>{body.label}</div>
          <MaskedInput
            className={"TextField-input"}
            type={"text"}
            id={body.id}
            ref={body.ref}
            value={this.state.giftCardNumber}
            onFocus={() => body.handleOnFocus}
            placeholder={"eg. 1234567890123456"}
            onBlur={() => {
              this.setState({ [body.id + "Touched"]: true });
            }}
            onChange={e => {
              this.handleGiftCardChange(e);
            }}
            mask={false}
            // placeholder={body.placeholder}
            guide={false}
            autoComplete={"off"}
          />
          <div className={"TextField-errorMessage"} style={{ height: "auto" }}>
            {inputCheck(this.state.vcardStep)}
          </div>
        </div>
      );
    };

    renderAmountTextField = () => {
      return (
        <MaskedInput
          className={"TextField-input"}
          type={"number"}
          value={this.props.currentAmount}
          onChange={e => {
            this.handleOnAmountChange(e);
          }}
          mask={false}
          placeholder={"$$"}
          guide={false}
          autoComplete={"off"}
        />
      );
    };

    renderPinTextField = () => {
      return (
        <div className={"TextField"}>
          <MaskedInput
            className={"TextField-input"}
            type={"text"}
            id="pin"
            ref="pin"
            value={this.state.vcardPinNumber}
            placeholder={"Enter PIN"}
            onChange={e => {
              this.handleGiftCardPinChange(e);
            }}
            mask={false}
            // placeholder={body.placeholder}
            guide={false}
            autoComplete={"off"}
          />
        </div>
      );
    }

    handleOnAmountChange = e => {
      let newAmount = e.currentTarget.value;
      if (newAmount < 0) newAmount = 0;
      /* Make sure all values add up correctly and stuff */ else if (
        newAmount > 50 /* total cart amount here */
      )
        newAmount = 50;
      this.setState({
        vcardAmount: newAmount
      });
      e.currentTarget.value = newAmount;
    };

    onClickAddGiftCard = isPoints => {
      // We might want to change how we're getting vcards
      const el = document.getElementById("vcard");

      // Set the card to be used here and also get the amounts for the card
      if (isPoints) {
        this.props.setGiftCardNumber(this.state.customerCardNumber);
        this.props.resetCurrentAmount();
      } else {
        this.props.setGiftCardNumber(el.value?.toUpperCase());
        this.props.resetCurrentAmount();
      }

      // This seems redundant but for some reason it doesn't work without it
      // Or maybe it does and I just didn't test it correctly
      let { currentCard, currentAmount, giftCards } = this.props;

      if (isPoints) {
        currentCard = this.state.customerCardNumber;
        currentAmount =
          this.state.pointsAmount < Number(this.state.pointsCustomAmount)
            ? this.state.pointsAmount
            : Number(this.state.pointsCustomAmount);
      } else {
        currentCard = this.state.giftCardNumber;
        currentAmount = this.state.giftcardAmount;
      }

      if (
        currentAmount !== 0 &&
        currentCard !== "" &&
        currentCard !== undefined &&
        currentCard !== null &&
        giftCards.find(e => e.giftcard_number === currentCard) === undefined
      ) {
        // validate amount
        let amount = currentAmount;
        // make sure total price - gift cards > 0
        if (amount > this.props.total) amount = this.props.total;
        // and only charge the max( totalprice - everythingelse, giftcard total )

        // add to cart
        if (amount > 0) {
          this.props.addGiftCard(amount);

          // reset input gift card text
          if (el && !isPoints) {
            el.value = "";
            this.setState({
              giftcardAmount: 0,
              vcardStep: InputStep.None,
              giftCardNumber: ""
            });
          }
          // reset input points text
          else if (isPoints) {
            this.setState({
              pointsAmount: 0,
              pcardStep: InputStep.None,
              customerCardNumber: ""
            });
          }
        } else if (!isPoints) {
          this.setState({ vcardStep: InputStep.ChargeOfZero });
        } else {
          this.setState({ pcardStep: InputStep.ChargeOfZero });
        }
      }
    };

    loginGoogle = async (google_response) => {
      try {
        // Get extra user info using access_token
        const userInfo = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${google_response.access_token}` },
        }).then(res => res.data);

        const result = await this.props.getPointsCard({ googleResponse: google_response, userInfo }, "google")
        this.setState({
          customerCardNumber: result
        });
        this.forcePointsCardChange();
      } catch (error) {
        this.setState({ displayHelp: true });
        console.error(error);
      }
    };

    loginFacebook = facebook_response => {
      this.props
        .getPointsCard(facebook_response, "facebook")
        .then(result => {
          this.setState({
            customerCardNumber: result
          });
          this.forcePointsCardChange();
        })
        .catch(error => {
          this.setState({ displayHelp: true });
          console.error(error);
        });
    };

    // -----------------

    closeModal = () => {
      this.props.handleClose();
      this.props.resetCurrentCard();
      if (this.props.usedLocalStorage) {
        this.setState({
          vcardStep: InputStep.None,
          vcardTouched: false,
          // pcardStep: InputStep.None,
          // pointsAmount: 0,
          giftcardAmount: 0,
          displayHelp: false,
          fineSelectPoints: false,
          // customerCardNumber: "",
          giftCardNumber: "",
          minAmountWarning: false
        });
      } else {
        this.setState({
          vcardStep: InputStep.None,
          vcardTouched: false,
          pcardStep: InputStep.None,
          pointsAmount: 0,
          giftcardAmount: 0,
          displayHelp: false,
          fineSelectPoints: false,
          customerCardNumber: "",
          giftCardNumber: ""
        });
      }

    };

    round = (value, decimals) => {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    }

    cancelModal = () => {
      this.closeModal();
      this.props.onCancel && this.props.onCancel();
    };

    acceptModal = () => {
      this.closeModal();
      this.props.onAccept && this.props.onAccept();
    };

    render() {
      const el = document.getElementById("vcard");
      if (el) {
        el.onkeyup = e => this.handleGiftCardKeyUp(e, el);
        el.onpaste = e => this.handleGiftCardKeyUp(e, el);
      }

      const points = document.getElementById("points");
      if (points) {
        points.onkeyup = e => this.handlePointsCardKeyUp(e, points);
        points.onpaste = e => this.handlePointsCardKeyUp(e, points);
      }

      if (this.props.isOpen) {
        return this.state.fineSelectPoints ? (
          /* This is where the person will be able to select the gift card amount that they'd like to use */

          <div className={"Modal"}>
            <div className={"Modal-shield"} onClick={this.cancelModal}>
              { }
            </div>
            <div className={"Modal-content"}>
              <div className={"Modal-title"}>POINTS</div>
              <div className={"Modal-body"}>
                <Grid container>
                  <Grid item xs={12}>
                    <div className={"TextField"}>
                      You have a total of:{" "}
                      {roundThis(Number(this.state.pointsAmount)).toFixed(2)} in
                      points
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className={"TextField"}>
                      This location requires you to use a minimum of{" "}
                      {this.props.currencySymbol}{roundThis(Number(this.props.base_price)).toFixed(2)}!
                    </div>
                    <div className={"TextField"}>
                      <div className={"TextField-label"}>
                        Enter the Amount of Points that you'd like to use!
                      </div>
                      <MaskedInput
                        className={"TextField-input"}
                        type={"money"}
                        // id={body.id}
                        // ref={body.ref}
                        value={this.round(this.state.pointsCustomAmount, 2)}
                        onFocus={() => {

                        }}
                        onBlur={() => {

                        }}
                        onChange={e => {
                          // Just some field validation. probably no the best way of doing this
                          if (e.target.value.match(/^[0-9]+(\.[0-9]{1,2})?$/gm) || e.target.value.match(/^[0-9]+(\.)?$/gm)) {
                            this.setState({ pointsCustomAmount: e.target.value });
                          } else if (!e.target.value) {
                            this.setState({ pointsCustomAmount: 0 });
                          } else {
                            e.target.value = this.state.pointsCustomAmount;
                          }
                        }}
                        mask={false}
                        placeholder={"Enter how many points you want to use"}
                        guide={false}
                        autoComplete={"off"}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row-reverse"
                  justify="flex-start"
                  alignItems="center"
                >
                  <Grid item xs={6} md={3}>
                    <div style={{ textAlign: "center" }}>
                      <CustomButton
                        text={"Add"}
                        onClick={() => {
                          this.onClickAddGiftCard(true);
                          this.setState({
                            update: true,
                            fineSelectPoints: false
                          });
                        }}
                        disabled={
                          this.round(parseFloat(this.state.pointsCustomAmount), 2) < this.round(parseFloat(this.props.base_price), 2) ||
                          this.round(parseFloat(this.state.pointsCustomAmount), 2) > this.round(this.props.total, 2)
                        }
                        style={{ width: "80%" }}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <div style={{ textAlign: "center" }}>
                      <CustomButton
                        text={"Cancel"}
                        onClick={() => {
                          this.setState({
                            fineSelectPoints: false
                          });
                        }}
                        style={{ width: "80%" }}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        ) : (
          /* This is where gift cards and points will be */
          <div className={"Modal"} style={{ "overflowY": "auto" }}>
            <div className={"Modal-shield"} onClick={this.cancelModal}>
              { }
            </div>
            <div className={"Modal-content"} style={{ "margin": "auto 0", "flex": "0 1 100%" }}>
              {this.props.enableGiftCard && (
                <div>
                  {/* -------------- Beginning of Gift Cards Here -------------- */}
                  <div
                    className={"Modal-title"}
                    style={{ fontWeight: "normal" }}
                  >
                    {this.props.title}
                  </div>
                  <div className={"Modal-body"}>
                    {/* GIFT CARD SPECIFIC ----------------- */}
                    {/* The style for this is in Checkout/Checkout.less */}
                    <table className={"Modal-table"}>
                      <tbody>
                        <tr>
                          <th className={"Modal-GiftCardAddButton"} colSpan="3" style={{ "width": "auto" }}>
                            <Grid container direction="row" justify="flex-start" alignItems="center">
                              <Grid item xs={12} md={12}>
                                {this.renderTextField({
                                  label: this.props.label,
                                  id: this.props.id,
                                  ref: this.props.ref
                                })}
                              </Grid>
                              {(!this.state.giftCardNumber.match("^[0-9.]+$")
                                && this.state.vcardStep === InputStep.PinNeeded) ?
                                (<Grid item xs={6} md={6}>
                                  {this.renderPinTextField()}
                                </Grid>)
                                : (<Grid item xs={6} md={6} style={{ "textAlign": "center" }}>
                                  {this.state.vcardStep === InputStep.LoadingBalance ?
                                    "LOADING" : this.props.currencySymbol +
                                    roundThis(this.state.giftcardAmount).toFixed(2)}
                                </Grid>)
                              }
                              <Grid item xs={6} md={6}>
                                <CustomButton
                                  text={"ADD"}
                                  onClick={() => {
                                    this.onClickAddGiftCard(false);
                                    this.setState({ update: true });
                                  }}
                                  disabled={
                                    this.state.vcardStep !== InputStep.FoundCard
                                  }
                                />
                              </Grid>
                            </Grid>
                          </th>
                        </tr>
                        {/* map applied gift cards here bud */}
                        {this.props.giftCards.filter(
                          gc => gc.giftcard_number.length !== 20
                        ).length > 0 && (
                            <tr className={"Modal-GiftCardArray"}>
                              <th>Applied Cards</th>
                              <th>Charge</th>
                              <th />
                            </tr>
                          )}
                        {this.props.giftCards &&
                          this.props.giftCards
                            .filter(gc => gc.giftcard_number.length !== 20)
                            .map((gc, i) => {
                              return (
                                <tr key={i} className={"Modal-GiftCardArray"}>
                                  <th className={"Modal-GiftCardArray-Number"}>
                                    {gc.giftcard_number.substr(0, 2) +
                                      gc.giftcard_number
                                        .substr(
                                          gc.giftcard_number.length - 4,
                                          4
                                        )
                                        .padStart(
                                          gc.giftcard_number.length - 2,
                                          "*"
                                        )}
                                  </th>
                                  <th className={"Modal-GiftCardBalance"}>
                                    {this.props.currencySymbol +
                                      roundThis(gc.amount_to_charge).toFixed(2)}
                                  </th>
                                  <th
                                    className={
                                      "Modal-GiftCardArray-RemoveButton"
                                    }
                                  >
                                    <CustomButton
                                      text={"REMOVE"}
                                      onClick={e => {
                                        this.props.removeGiftCard(
                                          gc.giftcard_number,
                                          gc.amount_to_charge
                                        );
                                        this.forceGiftCardChange();
                                        this.forcePointsCardChange();
                                      }}
                                    />
                                  </th>
                                </tr>
                              );
                            })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* -------------- MYSTUFF Beginning of Points Here -------------- */}
              <div className={"Modal-title"} style={{ fontWeight: "normal" }}>
                {this.props.pointsTitle}
              </div>
              <div className={"Modal-body"}>
                <table className={"Modal-table"}>
                  <tbody>
                    <tr>
                      <th className={"Modal-GiftCardAddButton"} colSpan="3">
                        <Grid container direction="row" justify="flex-start" alignItems="center">
                          <Grid item xs={12} md={7}>
                            {this.renderPointsTextField({
                              label: this.props.pointsLabel,
                              id: this.props.pointsId, // <----------------------------- I don't think this is the best way of doing this
                              ref: this.props.pointsRef
                            })}
                          </Grid>
                          <Grid item xs={6} md={2} style={{ "textAlign": "center" }}>
                            {this.props.currencySymbol +
                              roundThis(this.state.pointsAmount).toFixed(2)}
                          </Grid>
                          <Grid item xs={6} md={3}>
                            <CustomButton
                              text={"ADD"}
                              onClick={() => {
                                if (
                                  this.round(parseFloat(this.state.pointsAmount), 2) < this.round(parseFloat(this.props.base_price), 2) ||
                                  this.round(this.props.total, 2) < this.round(parseFloat(this.props.base_price), 2)) {
                                  this.setState({ minAmountWarning: true })
                                } else {
                                  this.setState({
                                    fineSelectPoints: true,
                                    pointsCustomAmount:
                                      this.state.pointsAmount <= this.props.total
                                        ? this.state.pointsAmount
                                        : this.props.total,
                                    displayHelp: false
                                  })
                                };
                              }}
                              disabled={
                                this.state.pcardStep !== InputStep.FoundCard
                              }
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <div
                              className={classNames(
                                "TextField",
                                this.props.className
                              )}
                            >
                              <div className={"TextField-label"}>
                                {this.props.pointsLoginDescription}
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={6} md={3}>
                            <GoogleLogin
                              text={this.props.googleButton}
                              onSuccess={this.loginGoogle}
                              onFailure={this.loginGoogle}
                              className="googlelogin"
                            />
                          </Grid>
                          <Grid item xs={6} md={3}>
                            <FacebookLogin
                              appId="333753770682611"
                              autoLoad={false}
                              disableMobileRedirect={true}
                              render={renderProps => (
                                <CustomButton
                                  onClick={renderProps.onClick}
                                  round
                                  color="primaryDark"
                                  // style={getButtonStyle()}
                                  text={this.props.facebookButton}
                                />
                              )}
                              fields="name,email,picture"
                              callback={this.loginFacebook}
                              className="fblogin"
                            />
                          </Grid>
                        </Grid>
                      </th>
                    </tr>
                    {/* map applied points cards here bud */}
                    {this.props.giftCards.filter(
                      gc => gc.giftcard_number.length === 20
                    ).length > 0 && (
                        <tr className={"Modal-GiftCardArray"}>
                          <th>Points Code</th>
                          <th>Charge</th>
                          <th />
                        </tr>
                      )}
                    {this.props.giftCards &&
                      this.props.giftCards
                        .filter(gc => gc.giftcard_number.length === 20)
                        .map((gc, i) => {
                          return (
                            <tr key={i} className={"Modal-GiftCardArray"}>
                              <th className={"Modal-GiftCardArray-Number"}>
                                {gc.giftcard_number.substr(0, 2) +
                                  gc.giftcard_number
                                    .substr(gc.giftcard_number.length - 4, 4)
                                    .padStart(
                                      gc.giftcard_number.length - 6,
                                      "*"
                                    )}
                              </th>
                              <th className={"Modal-GiftCardBalance"}>
                                {this.props.currencySymbol +
                                  roundThis(gc.amount_to_charge).toFixed(2)}
                              </th>
                              <th
                                className={"Modal-GiftCardArray-RemoveButton"}
                              >
                                <CustomButton
                                  text={"REMOVE"}
                                  onClick={() => {
                                    this.props.removeGiftCard(
                                      gc.giftcard_number,
                                      gc.amount_to_charge
                                    );
                                    this.forceGiftCardChange();
                                    this.forcePointsCardChange();
                                  }}
                                />
                              </th>
                            </tr>
                          );
                        })}
                    {this.state.displayHelp && (
                      <tr>
                        <th
                          colSpan="3"
                          style={{
                            padding: "0% 0 3% 0",
                            "textAlign": "center"
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              height: "12px",
                              borderBottom: "1px solid grey",
                              textAlign: "center",
                              margin: "20px 0 30px 0"
                            }}
                          />
                          {this.state.displayHelp && (
                            <div
                              className="FooterPulse"
                              style={{
                                display: "inline-block",
                                width: "100%"
                              }}
                            >
                              <div>{this.props.loginFailTextPart1}</div>
                              <div style={{ margin: "10px 0" }}>
                                {this.props.loginFailTextPart2}
                              </div>
                            </div>
                          )}
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={state.bookingLocation.country === "Canada" ? "https://www.ctrlv.ca/accounts" : "https://www.ctrlvarcade.com/accounts"}
                            onClick={() => {
                              this.setState({ displayHelp: false });
                            }}
                          >
                            {this.props.accountRedirect}
                          </a>
                        </th>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className={classNames({ "TextField-label": true, "Modal-PointWarning": true })}>
                {this.props.pointsRefundWarning}
              </div>

              {/* GIFT CARD SPECIFIC ----------------- */}
              {!this.props.isConfirm && (
                <div className={"Modal-continue"} onClick={this.acceptModal}>
                  {this.props.acceptText}
                </div>
              )}
              {this.props.isConfirm && (
                <div className={"Modal-acceptContainer"}>
                  <div className={"Modal-cancel"} onClick={this.cancelModal}>
                    {this.props.cancelText}
                  </div>
                  <div className={"Modal-accept"} onClick={this.acceptModal}>
                    {this.props.acceptText}
                  </div>
                </div>
              )}
              {this.state.minAmountWarning && (
                <div className={"Modal"}>
                  <div className={"Modal-shield"} onClick={() => { this.cancelModal() }}>
                    { }
                  </div>
                  <div className={"Modal-content"}>
                    <div className={"Modal-title"}>Points Error</div>
                    <div className={"Modal-body"}>
                      <div className={"TextField-label"}>
                        You cannot have less points than minimum base price or have a purchase less than the base price
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      } else {
        return null;
      }
    }
  }
);
